import { getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAI, GoogleAIBackend } from 'firebase/ai';

const firebaseConfig = {
  apiKey: 'AIzaSyB-mHEUw06OlUkaEGFLLKb84Kde3OaguB0',
  authDomain: 'cafe-receipts.firebaseapp.com',
  projectId: 'cafe-receipts',
  storageBucket: 'cafe-receipts.firebasestorage.app',
  messagingSenderId: '44640309227',
  appId: '1:44640309227:web:02735278b8ddebf3c253ae',
  measurementId: 'G-DZCET6XF36',
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const ai = getAI(app, { backend: new GoogleAIBackend() });
